import { useEffect, useState } from 'react';
import { FilterField, FilterForm } from '../../../../../components/tables/filterForms/FilterForm';
import SFCTable from '../../../../../components/tables/SFCTable';
import { useToast } from '../../../../../context/ToastContext';
import { useListFiltersInUrl } from '../../../../../hooks';

import { useGetAllDocumentsQuery } from '../../../../../services/endpoints/content/document';
import { Document } from '../../../../../types/content.type';

import { NavigateFunction, useNavigate } from 'react-router-dom';
import { SimpleButton } from '../../../../../components/buttons/SimpleButton';
import { User } from '../../../../../services/endpoints/people/user';
import { currentUserHasRole, getCurrentUser } from '../../../../../services/helper';
import { isGlobal } from '../../../../../utils/consts';
import { documentColumns } from '../../../../../utils/consts/columnDefs/contentColumns';
import { getFilterValue } from '../../../../../utils/listFilterSearchParams';

const defaultScope = '';

export const userCanEditCreateDelete_Documents = (user: User | null) => {
  if (user?.isAdmin && user?.isSuper) {
    return true;
  }
  if (user?.isWebContentEditor || user?.isSupremeAdmin) {
    return true;
  }

  return false;
};

export const DocumentsView = () => {
  const { addToast } = useToast();
  const [filters, setFilters] = useListFiltersInUrl({
    scope: defaultScope,
    data: { page: 1, entries: 10 }
  });
  const { data, error, isLoading, isFetching } = useGetAllDocumentsQuery(filters);

  const [documents, setDocuments] = useState<Document[]>([]);
  const isGlobalUser = currentUserHasRole(isGlobal);
  const navigate: NavigateFunction = useNavigate();

  const currentUser = getCurrentUser();

  const filterFormFields: FilterField[] = [
    {
      name: 'id',
      type: 'number',
      label: 'ID',
      value: getFilterValue(filters.data?.filterBy, 'id')
    },
    {
      name: 'title',
      label: 'Title',
      value: getFilterValue(filters.data?.filterBy, 'title')
    },
    {
      name: 'file_file_name',
      label: 'File Name',
      value: getFilterValue(filters.data?.filterBy, 'file_file_name')
    }
  ];

  if (!isGlobalUser) {
    filterFormFields.splice(4, 1);
  }

  useEffect(() => {
    if (error) {
      addToast('Error while loading data', 'error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error, isLoading]);

  useEffect(() => {
    if (data && data.results) {
      setDocuments(data.results);
    }
  }, [data]);

  const setFilterBy = (filterBy: { operator: string; field: string; value: string }[]) => {
    setFilters((prev) => ({
      ...prev,
      data: {
        ...prev!.data,
        filterBy
      }
    }));
  };

  return (
    <div className="py-2">
      <SFCTable
        name={`Documents`}
        columns={documentColumns}
        data={documents}
        count={data?.count}
        defaultScope={filters.scope ?? defaultScope}
        // scopes={buttons}
        isLoading={isLoading}
        isFetching={isFetching}
        indexDownloadPath="documents"
        filters={filters?.data?.filterBy}
        filterForm={
          <FilterForm
            fields={filterFormFields}
            onApplyFilters={setFilterBy}
          />
        }
        onFiltersChanged={setFilters}
        newItemEl={
          userCanEditCreateDelete_Documents(currentUser) && (
            <SimpleButton
              variant="sfc-blueberry"
              height={40}
              truncate={false}
              onClick={() => navigate('/admin/content/documents/new')}
            >
              New Document
            </SimpleButton>
          )
        }
      />
    </div>
  );
};
